import { type RoundMemberRole } from "@engine/round/actions";
import { type RoundMember } from "@engine/round/aggregate";

export const roundMemberRoleLabel: Record<RoundMemberRole, string> = {
  admin: "Admin",
  funder: "Funder",
  recommender: "Recommender",
};

export function rolesFromRoundMember(
  roundMember: RoundMember,
): RoundMemberRole[] {
  const activeEvaluators = Object.values(roundMember.evaluators).filter(
    (evaluator) => evaluator.status === "active",
  );

  return [
    roundMember.isRoundAdmin && "admin",
    activeEvaluators.some((evaluator) => evaluator.type === "funder") &&
      "funder",
    activeEvaluators.some((evaluator) => evaluator.type === "recommender") &&
      "recommender",
  ].filter(Boolean) as RoundMemberRole[];
}
